import { RiskIQAccess } from 'types/graphql-global-types';

export interface ProtocolInsightsPermissions {
    canView: boolean;
    canWriteComments: boolean;
    canEdit: boolean;
}

// What a Protocol Insights access level allows (ADO 90806). Mirrors IProtocolInsightsAccessService in OPRA Core;
// no level (not loaded, or not on the study team) means no access.
export const getProtocolInsightsPermissions = (
    access: RiskIQAccess | null | undefined,
): ProtocolInsightsPermissions => ({
    canView: !!access && access !== RiskIQAccess.NO_ACCESS,
    canWriteComments:
        access === RiskIQAccess.READ_ONLY_READ_WRITE_COMMENTS_ACCESS || access === RiskIQAccess.READ_WRITE_ACCESS,
    canEdit: access === RiskIQAccess.READ_WRITE_ACCESS,
});
